import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectDestructuringEmpty from "@babel/runtime/helpers/objectDestructuringEmpty";
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react';
import { useFeatureFlagByNameKey } from "../hooks/useFeatureFlagByNameKey";
import CrossPlatformNavigation from "./CrossPlatformNavigation";
import { CrossPlatformNavigationV2 } from "./cross-platform-navigation-v2";
import { DebuggerProvider, useDebugger } from "./debugger/debugger-context";
import { jsx as _jsx } from "react/jsx-runtime";
var NewCrossPlatformNavigation = function NewCrossPlatformNavigation(_ref) {
  var props = Object.assign({}, (_objectDestructuringEmpty(_ref), _ref));
  var _useFeatureFlagByName = useFeatureFlagByNameKey({
      nameKey: 'CROSS_NAVIGATION_V2'
    }),
    isV2Active = _useFeatureFlagByName.value,
    isLoading = _useFeatureFlagByName.loading;
  var _useDebugger = useDebugger(),
    sidebarVersion = _useDebugger.sidebarVersion,
    setShowHRISLinks = _useDebugger.setShowHRISLinks;
  var version = isV2Active ? 'v2' : sidebarVersion;

  // Force to show the HRIS links in the sidebar for users with the sidebar v2 active
  // biome-ignore lint/correctness/useExhaustiveDependencies: dependencies are intentional
  useEffect(function () {
    if (isV2Active) {
      setShowHRISLinks(true);
    }
  }, [isV2Active]);
  if (version === 'v2') {
    return /*#__PURE__*/_jsx(CrossPlatformNavigationV2, _objectSpread(_objectSpread({}, props), {}, {
      isGettingSidebarVersion: isLoading
    }));
  }
  return /*#__PURE__*/_jsx(CrossPlatformNavigation, _objectSpread(_objectSpread({}, props), {}, {
    isGettingSidebarVersion: isLoading
  }));
};

// HOC that wraps CrossPlatformNavigation with DebuggerProvider
var withDebuggerProvider = function withDebuggerProvider(WrappedComponent) {
  var HOC = function HOC(props) {
    return /*#__PURE__*/_jsx(DebuggerProvider, {
      children: /*#__PURE__*/_jsx(WrappedComponent, _objectSpread({}, props))
    });
  };
  return HOC;
};
export var CrossPlatformNavigationWithDebugger = /*#__PURE__*/withDebuggerProvider(NewCrossPlatformNavigation);
CrossPlatformNavigationWithDebugger.displayName = 'CrossPlatformNavigationWithDebugger';